/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Topic_LoadInputs */

const en_ui_more_stats_topic_load = /** @type {(inputs: Ui_More_Stats_Topic_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load`)
};

const de_ui_more_stats_topic_load = /** @type {(inputs: Ui_More_Stats_Topic_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last`)
};

/**
* | output |
* | --- |
* | "Load" |
*
* @param {Ui_More_Stats_Topic_LoadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_topic_load = /** @type {((inputs?: Ui_More_Stats_Topic_LoadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Topic_LoadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_topic_load(inputs)
	return de_ui_more_stats_topic_load(inputs)
});